export function MenuIcon() {
  return (
    <svg width={11} height={11} viewBox="0 0 11 11">
      <rect
        x="0.5"
        y="0.5"
        width="4"
        height="4"
        fill="none"
        stroke="currentColor"
      />
      <rect
        x="0.5"
        y="6.5"
        width="4"
        height="4"
        fill="none"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="0.5"
        width="4"
        height="4"
        fill="none"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="6.5"
        width="4"
        height="4"
        fill="none"
        stroke="currentColor"
      />
    </svg>
  );
}
